import Dashboard from "./Dashboard";
const DashboardWrapper = ({ userDetail, therapyPlans, patientTherapyRecord }) => (
    <Dashboard
      userDetail={userDetail}
      therapyPlans={therapyPlans}
      getPatientTherapyRecord={patientTherapyRecord}
    />
  );
  
  export default DashboardWrapper;